import {
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEES_FAILURE,
  CREATE_EMPLOYEE_REQUEST,
  CREATE_EMPLOYEE_SUCCESS,
  CREATE_EMPLOYEE_FAILURE,
  EMPLOYEE_DROPDOWN_REQUEST,
  EMPLOYEE_DROPDOWN_SUCCESS,
  EMPLOYEE_DROPDOWN_FAILURE,
  EMPLOYEE_DROPDOWN_AUTO_LIST_REQUEST,
  EMPLOYEE_DROPDOWN_AUTO_LIST_FAILURE,
  EMPLOYEE_DROPDOWN_AUTO_LIST_SUCCESS,
  FETCH_EMPLOYEE_TAB_WISE_INFO,
  FETCH_EMPLOYEE_TAB_WISE_INFO_SUCCESS,
  FETCH_EMPLOYEE_TAB_WISE_INFO_FAILURE,
  DELETE_DOCUMENT_REQUEST,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAILURE,
  FETCH_ACTIVE_EMPLOYEES_REQUEST,
  FETCH_ACTIVE_EMPLOYEES_SUCCESS,
  FETCH_ACTIVE_EMPLOYEES_FAILURE,
  FETCH_EMPLOYEE_VIEW_PROFILE_REQUEST,
  FETCH_EMPLOYEE_VIEW_PROFILE_SUCCESS,
  FETCH_EMPLOYEE_VIEW_PROFILE_FAILURE,
  FETCH_EMPLOYEELISTTOTRANSFER,
  FETCH_EMPLOYEELISTTOTRANSFER_SUCCESS,
  FETCH_EMPLOYEELISTTOTRANSFER_FAILURE,
  FETCH_TRANSFERLOGS,
  FETCH_TRANSFERLOGS_SUCCESS,
  FETCH_TRANSFERLOGS_FAILURE,
  SAVE_TRANSFER_REQUEST,
  SAVE_TRANSFER_SUCCESS,
  SAVE_TRANSFER_FAILURE,
  CLEAR_EMPLOYEE_LIST,
  FETCH_TRANSFER_TYPES,
  FETCH_TRANSFER_TYPES_SUCCESS,
  FETCH_TRANSFER_TYPES_FAILURE,
  FETCH_FROM_CATEGORY,
  FETCH_FROM_CATEGORY_SUCCESS,
  FETCH_FROM_CATEGORY_FAILURE,
  FETCH_FROM_DESIGNATION,
  FETCH_FROM_DESIGNATION_SUCCESS,
  FETCH_FROM_DESIGNATION_FAILURE,
  FETCH_FROM_DEPARTMENT,
  FETCH_FROM_DEPARTMENT_SUCCESS,
  FETCH_FROM_DEPARTMENT_FAILURE,
  FETCH_REPORTING_SUCCESS,
  FETCH_REPORTING,
  FETCH_REPORTING_FAILURE,
  GET_SHIFT_GROUP_DETAILS,
  EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_REQUEST,
  EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_SUCCESS,
  EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_FAILURE,
  FETCH_NEXT_EMP_NO_REQUEST,
  FETCH_NEXT_EMP_NO_SUCCESS,
  FETCH_NEXT_EMP_NO_FAILURE,
  EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_REQUEST,
  EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_SUCCESS,
  EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_FAILURE,
} from "./actionTypes";

// Action for fetching employee details
export const fetchEmployees = (formData) => ({
  type: FETCH_EMPLOYEES_REQUEST,
  payload: formData,
});

// Action for successful employee fetch
export const fetchEmployeesSuccess = (data) => ({
  type: FETCH_EMPLOYEES_SUCCESS,
  payload: data,
});

// Action for failed employee fetch
export const fetchEmployeesFailure = (error) => ({
  type: FETCH_EMPLOYEES_FAILURE,
  payload: error,
});

// Action for creating an employee
export const createEmployee = (data, tabName, history) => ({
  type: CREATE_EMPLOYEE_REQUEST,
  payload: { data, tabName, history },
});

// Action for successful employee creation
export const createEmployeeSuccess = (data) => ({
  type: CREATE_EMPLOYEE_SUCCESS,
  payload: data,
});

// Action for failed employee creation
export const createEmployeeFailure = (error) => ({
  type: CREATE_EMPLOYEE_FAILURE,
  payload: error,
});


export const fetchEmployeeDropdown = (unit_id) => ({
  type: EMPLOYEE_DROPDOWN_REQUEST,
  payload: { unit_id }
});

// Action for success response
export const fetchEmployeeDropdownSuccess = (data) => ({
  type: EMPLOYEE_DROPDOWN_SUCCESS,
  payload: data,
});

// Action for failure response
export const fetchEmployeeDropdownFailure = (error) => ({
  type: EMPLOYEE_DROPDOWN_FAILURE,
  payload: error,
});

export const fetchEmployeeDropdownAutoList = (unit_id) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_REQUEST,
  payload: { unit_id }
});

// Action for success response
export const fetchEmployeeDropdownAutoListSuccess = (data) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_SUCCESS,
  payload: data,
});

// Action for failure response
export const fetchEmployeeDropdownAutoListFailure = (error) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_FAILURE,
  payload: error,
});

// Action to fetch employee data tab-wise
export const fetchEmployeeTabWiseInfo = (empId, tabName) => ({
  type: FETCH_EMPLOYEE_TAB_WISE_INFO,
  payload: { empId, tabName },
});

// Success action when API call is successful
export const fetchEmployeeTabWiseInfoSuccess = (data) => ({
  type: FETCH_EMPLOYEE_TAB_WISE_INFO_SUCCESS,
  payload: data,
});

// Failure action when API call fails
export const fetchEmployeeTabWiseInfoFailure = (error) => ({
  type: FETCH_EMPLOYEE_TAB_WISE_INFO_FAILURE,
  payload: error,
});

export const deleteDocumentRequest = (formData) => ({
  type: DELETE_DOCUMENT_REQUEST,
  payload: formData,
});

export const deleteDocumentSuccess = (message) => ({
  type: DELETE_DOCUMENT_SUCCESS,
  payload: message,
});

export const deleteDocumentFailure = (error) => ({
  type: DELETE_DOCUMENT_FAILURE,
  payload: error,
});

// Action for fetching employee details
export const fetchActiveEmployees = (unit_id) => ({
  type: FETCH_ACTIVE_EMPLOYEES_REQUEST,
  payload: { unit_id },
});

export const fetchActiveEmployeesSuccess = (data) => ({
  type: FETCH_ACTIVE_EMPLOYEES_SUCCESS,
  payload: data,
});

export const fetchActiveEmployeesFailure = (error) => ({
  type: FETCH_ACTIVE_EMPLOYEES_FAILURE,
  payload: error,
});

export const fetchEmployeeViewProfileRequest = (emp_id) => ({
  type: FETCH_EMPLOYEE_VIEW_PROFILE_REQUEST,
  payload: { emp_id }
});

export const fetchEmployeeViewProfileSuccess = (profileData) => ({
  type: FETCH_EMPLOYEE_VIEW_PROFILE_SUCCESS,
  payload: profileData,
});

export const fetchEmployeeViewProfileFailure = (error) => ({
  type: FETCH_EMPLOYEE_VIEW_PROFILE_FAILURE,
  payload: error,
});

export const fetchTransferTypes = (unit_id) => ({
  type: FETCH_TRANSFER_TYPES,
  payload: { unit_id },
});

export const fetchTransferTypesSuccess = (data) => ({
  type: FETCH_TRANSFER_TYPES_SUCCESS,
  payload: data,
});

export const fetchTransferTypesFailure = (data) => ({
  type: FETCH_TRANSFER_TYPES_FAILURE,
  payload: data,
});

export const fetchCategory = (unit_id) => ({
  type: FETCH_FROM_CATEGORY,
  payload: { unit_id },
});

export const fetchCategorySuccess = (data) => ({
  type: FETCH_FROM_CATEGORY_SUCCESS,
  payload: data,
});

export const fetchCategoryFailure = (data) => ({
  type: FETCH_FROM_CATEGORY_FAILURE,
  payload: data,
});

export const fetchDesignation = (unit_id) => ({
  type: FETCH_FROM_DESIGNATION,
  payload: { unit_id },
});

export const fetchDesignationSuccess = (data) => ({
  type: FETCH_FROM_DESIGNATION_SUCCESS,
  payload: data,
});

export const fetchDesignationFailure = (data) => ({
  type: FETCH_FROM_DESIGNATION_FAILURE,
  payload: data,
});

export const fetchDepartment = (unit_id) => ({
  type: FETCH_FROM_DEPARTMENT,
  payload: { unit_id },
});

export const fetchDepartmentSuccess = (data) => ({
  type: FETCH_FROM_DEPARTMENT_SUCCESS,
  payload: data,
});

export const fetchDepartmentFailure = (data) => ({
  type: FETCH_FROM_DEPARTMENT_FAILURE,
  payload: data,
});
export const fetchEmployeeListtoTransfer = (payload) => ({
  type: FETCH_EMPLOYEELISTTOTRANSFER,
  payload,
});

export const fetchEmployeeListtoTransferSuccess = (data) => ({
  type: FETCH_EMPLOYEELISTTOTRANSFER_SUCCESS,
  payload: data,
});

export const fetchEmployeeListtoTransferFailure = (data) => ({
  type: FETCH_EMPLOYEELISTTOTRANSFER_FAILURE,
  payload: data,
});

export const fetchTransferLog = (unit_id) => ({
  type: FETCH_TRANSFERLOGS,
  payload: { unit_id },
});

export const fetchTransferLogsSuccess = (data) => ({
  type: FETCH_TRANSFERLOGS_SUCCESS,
  payload: data,
});

export const fetchTransferLogsFailure = (data) => ({
  type: FETCH_TRANSFERLOGS_FAILURE,
  payload: data,
});

export const saveEmployeeTransfer = (payload) => ({
  type: SAVE_TRANSFER_REQUEST,
  payload,
});

// Action for successful employee creation
export const SaveTransferSuccess = (data) => ({
  type: SAVE_TRANSFER_SUCCESS,
  payload: data,
});

// Action for failed employee creation
export const SaveTransferFailure = (error) => ({
  type: SAVE_TRANSFER_FAILURE,
  payload: error,
});
export const clearEmployeeList = () => ({
  type: CLEAR_EMPLOYEE_LIST,
  payload: [],
});

export const fetchReporting = (unit_id) => ({
  type: FETCH_REPORTING,
  payload: { unit_id },
});

export const fetchReportingSuccess = (data) => ({
  type: FETCH_REPORTING_SUCCESS,
  payload: data,
});

export const fetchReportingFailure = (data) => ({
  type: FETCH_REPORTING_FAILURE,
  payload: data,
});

export const getShiftGroupDetails = (unitid, groupid) => ({
  type: GET_SHIFT_GROUP_DETAILS,
  payload: { unitid, groupid },
});

export const fetchEmployeeDropdownAutoExtraDutyList = (unit_id) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_REQUEST,
  payload: { unit_id }
});

// Action for success response
export const fetchEmployeeDropdownAutoExtraDutyListSuccess = (data) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_SUCCESS,
  payload: data,
});

// Action for failure response
export const fetchEmployeeDropdownAutoExtraDutyListFailure = (error) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_FAILURE,
  payload: error,
});

//EmpSeqNumber Actions
export const fetchNextEmpNoRequest = (unit_id, cat_id) => ({
  type: FETCH_NEXT_EMP_NO_REQUEST,
  payload: { unit_id, cat_id },
});

export const fetchNextEmpNoSuccess = (data) => ({
  type: FETCH_NEXT_EMP_NO_SUCCESS,
  payload: data,
});

export const fetchNextEmpNoFailure = (error) => ({
  type: FETCH_NEXT_EMP_NO_FAILURE,
  payload: error,
});


export const fetchEmployeeDropdownAutoListMobilePunch = (unit_id, create_by) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_REQUEST,
  payload: { unit_id, create_by }
});

// Action for success response
export const fetchEmployeeDropdownAutoListMobilePunchSuccess = (data) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_SUCCESS,
  payload: data,
});

// Action for failure response
export const fetchEmployeeDropdownAutoListMobilePunchFailure = (error) => ({
  type: EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_FAILURE,
  payload: error,
});